/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ComputationSummary } from './ComputationSummary';
import {
    ComputationSummaryFromJSON,
    ComputationSummaryFromJSONTyped,
    ComputationSummaryToJSON,
} from './ComputationSummary';
import type { DurationsByType } from './DurationsByType';
import {
    DurationsByTypeFromJSON,
    DurationsByTypeFromJSONTyped,
    DurationsByTypeToJSON,
} from './DurationsByType';
import type { PrefixDurations } from './PrefixDurations';
import {
    PrefixDurationsFromJSON,
    PrefixDurationsFromJSONTyped,
    PrefixDurationsToJSON,
} from './PrefixDurations';

/**
 * 
 * @export
 * @interface ClusterAnalyticsSummary
 */
export interface ClusterAnalyticsSummary {
    /**
     * 
     * @type {DurationsByType}
     * @memberof ClusterAnalyticsSummary
     */
    durationsTotal: DurationsByType;
    /**
     * 
     * @type {Array<PrefixDurations>}
     * @memberof ClusterAnalyticsSummary
     */
    durationsByPrefix?: Array<PrefixDurations>;
    /**
     * 
     * @type {Array<ComputationSummary>}
     * @memberof ClusterAnalyticsSummary
     */
    computations: Array<ComputationSummary>;
    /**
     * 
     * @type {number}
     * @memberof ClusterAnalyticsSummary
     */
    threadSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof ClusterAnalyticsSummary
     */
    nTasks?: number;
    /**
     * 
     * @type {number}
     * @memberof ClusterAnalyticsSummary
     */
    nTasksDone?: number;
    /**
     * 
     * @type {Date}
     * @memberof ClusterAnalyticsSummary
     */
    lastSeen?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClusterAnalyticsSummary
     */
    idleSince?: Date;
    /**
     * 
     * @type {number}
     * @memberof ClusterAnalyticsSummary
     */
    idleTimeout?: number;
    /**
     * 
     * @type {number}
     * @memberof ClusterAnalyticsSummary
     */
    idleDuration?: number;
}

/**
 * Check if a given object implements the ClusterAnalyticsSummary interface.
 */
export function instanceOfClusterAnalyticsSummary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "durationsTotal" in value;
    isInstance = isInstance && "computations" in value;

    return isInstance;
}

export function ClusterAnalyticsSummaryFromJSON(json: any): ClusterAnalyticsSummary {
    return ClusterAnalyticsSummaryFromJSONTyped(json, false);
}

export function ClusterAnalyticsSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClusterAnalyticsSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'durationsTotal': DurationsByTypeFromJSON(json['durations_total']),
        'durationsByPrefix': !exists(json, 'durations_by_prefix') ? undefined : ((json['durations_by_prefix'] as Array<any>).map(PrefixDurationsFromJSON)),
        'computations': ((json['computations'] as Array<any>).map(ComputationSummaryFromJSON)),
        'threadSeconds': !exists(json, 'thread_seconds') ? undefined : json['thread_seconds'],
        'nTasks': !exists(json, 'n_tasks') ? undefined : json['n_tasks'],
        'nTasksDone': !exists(json, 'n_tasks_done') ? undefined : json['n_tasks_done'],
        'lastSeen': !exists(json, 'last_seen') ? undefined : (new Date(json['last_seen'])),
        'idleSince': !exists(json, 'idle_since') ? undefined : (new Date(json['idle_since'])),
        'idleTimeout': !exists(json, 'idle_timeout') ? undefined : json['idle_timeout'],
        'idleDuration': !exists(json, 'idle_duration') ? undefined : json['idle_duration'],
    };
}

export function ClusterAnalyticsSummaryToJSON(value?: ClusterAnalyticsSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'durations_total': DurationsByTypeToJSON(value.durationsTotal),
        'durations_by_prefix': value.durationsByPrefix === undefined ? undefined : ((value.durationsByPrefix as Array<any>).map(PrefixDurationsToJSON)),
        'computations': ((value.computations as Array<any>).map(ComputationSummaryToJSON)),
        'thread_seconds': value.threadSeconds,
        'n_tasks': value.nTasks,
        'n_tasks_done': value.nTasksDone,
        'last_seen': value.lastSeen === undefined ? undefined : (value.lastSeen.toISOString()),
        'idle_since': value.idleSince === undefined ? undefined : (value.idleSince.toISOString()),
        'idle_timeout': value.idleTimeout,
        'idle_duration': value.idleDuration,
    };
}

